// UI workflow types — re-export backend domain enums to avoid frontend/backend drift

// Re-export domain enums from backend — single source of truth for workflow values
export {
  WorkflowTypes,
  WorkflowSubtype,
  State,
  ExecutionResult,
  WorkflowState,
  WorkflowLifecycleType,
  WorkflowLifecycleStage,
} from '../../../functions/src/workflows/domain/workflow';

export type {
  WorkflowLifecycle,
  MigrateContactsArgs,
} from '../../../functions/src/workflows/domain/workflow';

import type { Workflow as BackendWorkflow } from '../../../functions/src/workflows/domain/workflow';

/** RTDB workflow record as displayed in the UI (key + client-set fields). */
export interface Workflow extends BackendWorkflow {
  key?: string;
  createdBy?: { uid: string; email: string };
}

export const workflowTypesMap = {
  migrate_contacts: 'Migrate Contacts',
};

export const WorkflowSubtypeMap = {
  exile: 'Exile',
  data_transfer: 'Data Transfer',
  data_migration: 'Data Migration',
};
